<!-- IMPORTANT! add class 'tl-wrapper' outside this slot -->
<template>
	<div>
		<div class="card-timeline m-t-8" @click="collapse">
			<div class="card-timeline-title" :class="{'card-timeline-title-hide': !show}">
				<div class="row">
					<div class="col-10 f-regular f-14 f-c-midgrey" :class="{'ellipsis-container nomore': !show}"
					     v-html="title">
					</div>
					<div class="col-2 text-right">
						<img :class="{'card-timeline-content-show': show, 'card-timeline-content-hide': !show}"
						     src="@/assets/icon-sidebar/chevron-down.svg" alt="">
					</div>
				</div>
			</div>
			<div class="card-timeline-content" v-show="isContentShow" :id="id">
				<slot name="content"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTimelineCard",
	props: {
		title: {
			type: String,
			default: "",
		},
		id: {
			type: String,
			default: "",
		},
		isContentShow: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			show: false
		}
	},
	mounted() {
		this.show = this.isContentShow
	},
	methods: {
		collapse() {
			$("#" + this.id).slideToggle()
			this.show = !this.show
		}
	}
}
</script>

<style scoped>
.card-timeline {
	border: 1px solid #C8D0DD;
	border-radius: 4px;
}

.card-timeline-title {
	background: #F6F6F6;
	padding: 8px 12px;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.card-timeline-title-hide {
	background: #F6F6F6;
	padding: 8px 12px;
	border-radius: 4px;
}

.card-timeline-content {
	padding: 0 12px;
}

.card-timeline-content-show {
	transform: rotate(180deg);
	transition: all ease-in-out 300ms;
}

.card-timeline-content-hide {
	transform: rotate(0deg);
	transition: all ease-in-out 300ms;
}

.ellipsis-container {
	width: 200px;
}
</style>